import React, { memo, useCallback, useEffect, useState } from 'react'

import { BackButton, LogoImage, LogoWrapper } from './header-section-styles'
import { useTranslation } from './../../../hooks/locale'
import { BackIcon } from './../../common/icons'
import { isPlatformAndroidOrIOS } from './../../../utils/platform-utils'
import { HeaderSectionTransport } from './../../../transports/region-landing-page-transport'

type Navigation = HeaderSectionTransport['navigationSectionResponse']['navigation']

interface LogoAreaProps {
    logo: Navigation['logo']
    showBackButton?: boolean
}

const LogoArea: React.FC<LogoAreaProps> = ({ logo, showBackButton = true }) => {
    const { t } = useTranslation()
    const [isApp, setIsApp] = useState(false)

    useEffect(() => {
        setIsApp(isPlatformAndroidOrIOS)
    }, [])

    const goBack = useCallback(() => {
        globalThis?.history?.back()
    }, [])

    if (isApp && showBackButton) {
        return (
            <BackButton onClick={goBack}>
                <BackIcon aria-label={t('backIconText')} />
            </BackButton>
        )
    }

    if (!logo?.image?.url) {
        return null
    }

    return (
        <LogoWrapper href={logo.url}>
            <LogoImage src={logo.image ? logo.image.url : ''} alt={'Logo'} />
        </LogoWrapper>
    )
}

export default memo(LogoArea)
